module.exports = __webpack_public_path__ + "static/media/whatsapp_button_on.6081039c.svg";